import React, { useEffect } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box, Tooltip, Typography } from '@material-ui/core'
import { Formik, Field } from 'formik'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Button from '@material-ui/core/Button'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'

import { useDropDownListLazyQuery } from '@src/queries/CrisprgrnaSpecificationDetailsQuery.generated'
import { useCrisprgRnaPriceCallMutation } from '@src/mutations/SemiconfigCrisprgrnaMutation.generated'
import { semiConfigContext, ProductDetails } from '../Crisprgna'
import { crisprgrnaRoute, useRouter } from '@src/routes'
import ErrorAlert from '../../../../Configurators/components/ErrorAlert'
import {
  SpecificationMessages,
  ActiveLinkType,
  EU_COUNTRY_CODES,
} from '../Enum'
import { initialState } from '../Reducer'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import InfoIcon from '@material-ui/icons/Info'
import CrisprgrnaRecommendationPopUp from '@src/routes/SemiConfigurators/components/PopUp/CrisprgrnaRecommendationPopUp'
import clsx from 'clsx'
import { SemiConfiguratorValues } from '../../../utils/constants'
import PerformanceGuaranteePopUp from '@src/routes/SemiConfigurators/components/PopUp/PerformanceGuaranteePopUp'
import CustomCrisprSolutionsPopUp from '@src/routes/SemiConfigurators/components/PopUp/CustomCrisprSolutionsPopUp'
import Link from '@material-ui/core/Link'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 10),
      marginBottom: theme.spacing(5),
    },
    label: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
    },
    specificationsWrapper: {
      '& span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    radio: {
      padding: theme.spacing(1),
      color: 'rgba(0,0,0,0.1)',
    },
    linkStyle: {
      color: theme.palette.primary.main,
    },
    linkFontWeight: {
      fontWeight: 600,
    },
    vectorLabel: {
      fontSize: theme.typography.pxToRem(13),
    },
    vectorLabel2: {
      paddingBottom: theme.spacing(1),
    },
    nextButton: {
      marginTop: theme.spacing(4),
      minWidth: 220,
      height: theme.spacing(12),
    },
    hideRow: {
      display: 'none',
    },
    textColor: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(13),
      paddingTop: theme.spacing(2),
    },
    noDrop: {
      '& .MuiFormControlLabel-root': {
        cursor: 'no-drop',
      },
      '& .Mui-disabled': {
        cursor: 'no-drop',
      },
    },
    fieldLabel: {
      marginTop: theme.spacing(5),
      '& label': {
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        width: 'fit-content',
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 35,
          lineHeight: theme.typography.pxToRem(25),
        },
      },
    },
    fieldLabelPadding: {
      paddingLeft: theme.spacing(1.5),
    },
    InfoPopup: {
      maxWidth: theme.spacing(150),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      boxShadow: theme.shadows[4],
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.black,
      borderRadius: '2%',
      marginBottom: theme.spacing(1),
    },
    marginPopup: {
      maxWidth: theme.spacing(160),
      marginBottom: theme.spacing(0),
      marginTop: theme.spacing(1.5),
    },
    arrow: {
      color: theme.palette.common.white,
    },
    arrow1: {
      color: theme.palette.common.white,
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    recommendationText: {
      position: 'relative',
      marginTop: theme.spacing(5),
    },
    customCrisprSolnLink: {
      position: 'relative',
      marginTop: theme.spacing(-5),
    },
    purificationHelpText: {
      marginBottom: theme.spacing(2),
    },
  }
})

interface SpecificationsProps {
  productDetails: ProductDetails
}

const Specifications: React.FC<SpecificationsProps> = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const [getDropDownList, { data, loading: dropdownload }] =
    useDropDownListLazyQuery()
  const [defaultTrueForStructure, setdefaultTrueForStructure] =
    React.useState(false)
  const [defaultTrueForScale, setdefaultTrueForScale] = React.useState(false)
  const [reqPhysical, setReqPhysical] = React.useState(false)
  const [reqSpecies, setReqSpecies] = React.useState(false)
  const [reqStructure, setReqStructure] = React.useState(false)
  const [reqScale, setReqScale] = React.useState(false)
  const [reqMod, setReqMod] = React.useState(false)
  const [reqPuri, setReqPuri] = React.useState(false)
  const { state, dispatch } = React.useContext(semiConfigContext)
  const [selectedMaterial, setSelectedMaterial] = React.useState('noSelection')
  const [titer, setTiter] = React.useState('powerof6')
  const [volume, setVolume] = React.useState('pointTwo')
  const [lentiVirus, setLentiVirus] = React.useState('LV01')
  const [aliquotings, setAliquotings] = React.useState('Mul1X200')
  const [aliqFlag, setAliqFlag] = React.useState(false)
  const [volFlag, setVolFlag] = React.useState(false)
  const [amount, setAmount] = React.useState('one')
  const [vector, setVector] = React.useState('LV01')
  const [open, setOpen] = React.useState(false)
  const [defaultTrue, setDefaultTrue] = React.useState(false)
  const router = useRouter()
  const [loader, setLoader] = React.useState(false)
  const message = intl.formatMessage(
    messages.CONF_SELECT_REQUIRED_FIELD_crispgrna
  )
  const { dropDownResponseList } = state
  const vectorURL =
    '/technical-documents/technical-article/genomics/advanced-gene-editing/crispr-clone-control-and-cas9-essentials#Lentiviral%20vectors'
  const [isEurope, setIsEurope] = React.useState(false)

  const setInitialState = (): void => {
    dispatch({ type: 'TRACE_ON_CLICK', data: true })
    dispatch({
      type: 'UPDATE_PRICE_CALL_RESPONSE',
      data: initialState.priceCallResponse,
    })
  }

  const onPageLoadTiterValues = (): void => {
    if (
      state.priceCallData.physicalFormat.titer !== '' &&
      state.priceCallData.physicalFormat.titer !== undefined
    ) {
      if (
        state.priceCallData.physicalFormat.titer ===
        SpecificationMessages.TenPSix
      ) {
        setTiter(SpecificationMessages.powerof6)
      } else if (
        state.priceCallData.physicalFormat.titer ===
        SpecificationMessages.TenPSeven
      ) {
        setTiter(SpecificationMessages.powerof7)
      } else if (
        state.priceCallData.physicalFormat.titer ===
        SpecificationMessages.TenPEight
      ) {
        setTiter(SpecificationMessages.powerof8)
      } else if (
        state.priceCallData.physicalFormat.titer ===
        SpecificationMessages.TenPNine
      ) {
        setTiter(SpecificationMessages.powerof9)
      }
    }
  }

  const onPageLoadLentiVirusValues = (): void => {
    if (
      state.priceCallData.physicalFormat.lentivirusBackbone !== '' &&
      state.priceCallData.physicalFormat.lentivirusBackbone !== undefined
    ) {
      setLentiVirus(state.priceCallData.physicalFormat.lentivirusBackbone)
    }
  }

  const onPageLoadVolumeValues = (): void => {
    if (
      state.priceCallData.physicalFormat.volume !== '' &&
      state.priceCallData.physicalFormat.volume !== undefined
    ) {
      setVolFlag(true)
      if (
        state.priceCallData.physicalFormat.volume ===
        SpecificationMessages.dotTwo
      ) {
        setVolume(SpecificationMessages.pointTwo)
      } else if (
        state.priceCallData.physicalFormat.volume ===
        SpecificationMessages.dotOne
      ) {
        setVolume(SpecificationMessages.pointOne)
      } else if (
        state.priceCallData.physicalFormat.volume ===
        SpecificationMessages.oneVol
      ) {
        setVolume(SpecificationMessages.volOne)
      } else if (
        state.priceCallData.physicalFormat.volume ===
        SpecificationMessages.twoVol
      ) {
        setVolume(SpecificationMessages.volTwo)
      } else if (
        state.priceCallData.physicalFormat.volume ===
        SpecificationMessages.fiveVol
      ) {
        setVolume(SpecificationMessages.volFive)
      }
    }
  }

  const onPageLoadAliquoteValues = (): void => {
    if (
      state.priceCallData.physicalFormat.aliquot !== '' &&
      state.priceCallData.physicalFormat.aliquot !== undefined
    ) {
      setAliqFlag(true)
      if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul1x200
      ) {
        setAliquotings(SpecificationMessages.Mul1X200)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul2X100
      ) {
        setAliquotings(SpecificationMessages.Mul2X100)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul4X50
      ) {
        setAliquotings(SpecificationMessages.Mul4X50)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul8X25
      ) {
        setAliquotings(SpecificationMessages.Mul8X25)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul5X20
      ) {
        setAliquotings(SpecificationMessages.Mul5X20)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul2X50
      ) {
        setAliquotings(SpecificationMessages.Mul2X50)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul4X25
      ) {
        setAliquotings(SpecificationMessages.Mul4X25)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul5X200
      ) {
        setAliquotings(SpecificationMessages.Mul5X200)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul10X100
      ) {
        setAliquotings(SpecificationMessages.Mul10X100)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul20X50
      ) {
        setAliquotings(SpecificationMessages.Mul20X50)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul40X25
      ) {
        setAliquotings(SpecificationMessages.Mul40X25)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul25X200
      ) {
        setAliquotings(SpecificationMessages.Mul25X200)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul50X100
      ) {
        setAliquotings(SpecificationMessages.Mul50X100)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul100X50
      ) {
        setAliquotings(SpecificationMessages.Mul100X50)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul200X25
      ) {
        setAliquotings(SpecificationMessages.Mul200X25)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul10X200
      ) {
        setAliquotings(SpecificationMessages.Mul10X200)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul20X100
      ) {
        setAliquotings(SpecificationMessages.Mul20X100)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul40X50
      ) {
        setAliquotings(SpecificationMessages.Mul40X50)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul80X25
      ) {
        setAliquotings(SpecificationMessages.Mul80X25)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul50X20
      ) {
        setAliquotings(SpecificationMessages.Mul50X20)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul100X20
      ) {
        setAliquotings(SpecificationMessages.Mul100X20)
      } else if (
        state.priceCallData.physicalFormat.aliquot ===
        SpecificationMessages.mul10X20
      ) {
        setAliquotings(SpecificationMessages.Mul10X20)
      }
    }
  }

  const onPageLoadVectorValues = (): void => {
    if (
      state.priceCallData.physicalFormat.vector !== '' &&
      state.priceCallData.physicalFormat.vector !== undefined
    ) {
      setVector(state.priceCallData.physicalFormat.vector)
    }
  }

  const onPageLoadAmount = (): void => {
    if (
      state.priceCallData.physicalFormat.amount !== '' &&
      state.priceCallData.physicalFormat.amount !== undefined
    ) {
      if (
        state.priceCallData.physicalFormat.amount ===
        SpecificationMessages.oneVol
      ) {
        setAmount(SpecificationMessages.oneRom)
      } else if (
        state.priceCallData.physicalFormat.amount === SpecificationMessages.ten
      ) {
        setAmount(SpecificationMessages.tenRom)
      } else if (
        state.priceCallData.physicalFormat.amount ===
        SpecificationMessages.TwentyFive
      ) {
        setAmount(SpecificationMessages.twentyFiveRom)
      } else if (
        state.priceCallData.physicalFormat.amount ===
        SpecificationMessages.hundred
      ) {
        setAmount(SpecificationMessages.hundredRom)
      }
    }
  }

  React.useEffect(() => {
    if (state.dropDownValue.physicalMaterial !== '') {
      setSelectedMaterial(state.dropDownValue.physicalMaterial)
    }
    if (state.dropDownValue.physicalMaterial === SpecificationMessages.VIRUS) {
      onPageLoadTiterValues()
      onPageLoadLentiVirusValues()
      onPageLoadVolumeValues()
      onPageLoadAliquoteValues()
    }
    if (state.dropDownValue.physicalMaterial === SpecificationMessages.DNA) {
      onPageLoadVectorValues()
      onPageLoadAmount()
    }
    if (EU_COUNTRY_CODES.includes(props.productDetails.countryCode)) {
      setIsEurope(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  React.useEffect(() => {
    if (state.dropDownValue.physicalMaterial === SpecificationMessages.RNA) {
      setReqPhysical(false)
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        (state.priceCallData.physicalFormat.species === '' ||
          state.priceCallData.physicalFormat.scale === '' ||
          state.priceCallData.physicalFormat.modification === '' ||
          state.priceCallData.physicalFormat.purification === '' ||
          state.priceCallData.physicalFormat.structure === '')
      ) {
        setOpen(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.species === ''
      ) {
        setReqSpecies(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.structure === ''
      ) {
        setReqStructure(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.scale === ''
      ) {
        setReqScale(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.modification === ''
      ) {
        setReqMod(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.purification === ''
      ) {
        setReqPuri(true)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.species !== '' &&
        state.priceCallData.physicalFormat.scale !== '' &&
        state.priceCallData.physicalFormat.modification !== '' &&
        state.priceCallData.physicalFormat.purification !== '' &&
        state.priceCallData.physicalFormat.structure !== ''
      ) {
        setOpen(false)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.species !== ''
      ) {
        setReqSpecies(false)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.structure !== ''
      ) {
        setReqStructure(false)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.scale !== ''
      ) {
        setReqScale(false)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.modification !== ''
      ) {
        setReqMod(false)
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.priceCallData.physicalFormat.purification !== ''
      ) {
        setReqPuri(false)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  useEffect(() => {
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    window.scrollTo(0, 0)
  }, [])

  const dropDownResult = async (obj): Promise<void> => {
    await getDropDownList({ variables: { input: { ...obj } } })
  }

  const [crisprgRnaPriceCall, { loading: priceload }] =
    useCrisprgRnaPriceCallMutation()

  const semiCrisprgrnaPriceCall = async (obj): Promise<void> => {
    const response: any = await crisprgRnaPriceCall({
      variables: { input: obj, productInput: props.productDetails },
    })
    if (response.data) {
      if (!response.data.crisprgRnaPriceCall.serverError) {
        dispatch({
          type: 'UPDATE_PRICE_CALL_RESPONSE',
          data: response.data.crisprgRnaPriceCall,
        })

        if (
          (selectedMaterial === SpecificationMessages.RNA &&
            state.priceCallData.physicalFormat.species !== '' &&
            state.priceCallData.physicalFormat.scale !== '' &&
            state.priceCallData.physicalFormat.modification !== '' &&
            state.priceCallData.physicalFormat.purification !== '' &&
            state.priceCallData.physicalFormat.structure !== '') ||
          selectedMaterial === SpecificationMessages.DNA ||
          selectedMaterial === SpecificationMessages.VIRUS
        ) {
          const url = `${crisprgrnaRoute.index()}?activeLink=${
            ActiveLinkType.ReviewOrder
          }`
          router.push(url)
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
  }

  interface DropDownData {
    label: string
    value: string
  }

  const dropDownData: DropDownData = {
    label: '',
    value: '',
  }

  const getData = (data) => {
    return data.map((item) => {
      const result = {}
      const keys = Object.keys(item)
      keys.forEach((o) => {
        if (item[o]) {
          result[o] = item[o]
        }
      })
      return result
    })
  }

  const dropdownType = (dropDownResponseList): DropDownData[] => {
    const dropDownList = [dropDownData]
    if (dropDownResponseList.physicalMaterial !== null) {
      const result = getData(dropDownResponseList.physicalMaterial)
      dropDownList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        dropDownList.push({ ...dropDownData })
      })
    }
    return dropDownList
  }

  const vectorDNADropdown = (dropDownResponseList): DropDownData[] => {
    const vectorList = [dropDownData]
    if (dropDownResponseList.vector !== null) {
      const result = getData(dropDownResponseList.vector)
      vectorList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        vectorList.push({ ...dropDownData })
      })
    }
    return vectorList
  }

  const amountDNADropdown = (dropDownResponseList): DropDownData[] => {
    const amountList = [dropDownData]
    if (dropDownResponseList.amount !== null) {
      const result = getData(dropDownResponseList.amount)
      amountList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        amountList.push({ ...dropDownData })
      })
    }
    return amountList
  }

  const lentivirusDNADropdown = (dropDownResponseList): DropDownData[] => {
    const lentivirusList = [dropDownData]
    if (dropDownResponseList.lentivirusBackbone !== null) {
      const result = getData(dropDownResponseList.lentivirusBackbone)
      lentivirusList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        lentivirusList.push({ ...dropDownData })
      })
    }
    return lentivirusList
  }

  const titerDropdown = (dropDownResponseList): DropDownData[] => {
    const titerList = [dropDownData]

    if (dropDownResponseList.titer !== null) {
      const result = getData(dropDownResponseList.titer)
      titerList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        titerList.push({ ...dropDownData })
      })
    }
    return titerList
  }

  const volumeDropdown = (dropDownResponseList): DropDownData[] => {
    const volumeList = [dropDownData]

    if (dropDownResponseList.volume !== null) {
      const result = getData(dropDownResponseList.volume)
      volumeList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        volumeList.push({ ...dropDownData })
      })
      if (!volFlag) {
        const volValue: [any] = result[0]
        setVolume(Object.keys(volValue)[0])
        const volData = Object.values(volValue)[0]
        if (volData === SpecificationMessages.dotOneVal) {
          state.priceCallData.physicalFormat.volume =
            SpecificationMessages.dotOne
          state.specificationValues.volume = volData
        } else if (volData === SpecificationMessages.dotTwoVal) {
          state.priceCallData.physicalFormat.volume =
            SpecificationMessages.dotTwo
          state.specificationValues.volume = volData
        }
      }
    }
    return volumeList
  }

  const aliquotingDropdown = (dropDownResponseList): DropDownData[] => {
    const aliquotingList = [dropDownData]
    if (dropDownResponseList.aliquot !== null) {
      const result = getData(dropDownResponseList.aliquot)

      aliquotingList.length = 0
      result.forEach((sc) => {
        delete sc.__typename
        dropDownData.label = Object.values(sc).toString()
        dropDownData.value = Object.keys(sc).toString()
        aliquotingList.push({ ...dropDownData })
      })
      if (!aliqFlag) {
        const aliqValue: [any] = result[0]
        setAliquotings(Object.keys(aliqValue)[0])

        const val = Object.values(aliqValue)[0]
        const filteredVal = val
          .substring(0, val.length - 2)
          .toString()
          .trim()

        state.priceCallData.physicalFormat.aliquot = filteredVal
        state.specificationValues.aliquot = `${filteredVal} ${SpecificationMessages.microLtr}`
      }
    }
    return aliquotingList
  }

  const getValue = (event, keys): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    if (keys === SpecificationMessages.CRISPRSpecies) {
      const speciesValue = event.target.value
      if (speciesValue === SpecificationMessages.SPCAS9) {
        setdefaultTrueForStructure(false)
        state.dropDownValue.structure = ''
        state.specificationValues.structure = ''
        prciePhysicalFormat.structure = ''
        state.dropDownValue.species = SpecificationMessages.SPCAS9
        state.specificationValues.species = SpecificationMessages.SPCAS9Val
      } else if (speciesValue === SpecificationMessages.FNCAS9) {
        setdefaultTrueForStructure(true)
        setReqStructure(false)
        state.dropDownValue.structure = SpecificationMessages.CRRNA
        prciePhysicalFormat.structure = SpecificationMessages.CRRNA
        state.dropDownValue.species = SpecificationMessages.FNCAS9
        state.specificationValues.species = SpecificationMessages.FNCAS9Val
        state.specificationValues.structure = SpecificationMessages.CRRNAVal
      }
      setReqSpecies(false)
      prciePhysicalFormat.species = speciesValue
      prciePhysicalFormat.scale = ''
      state.specificationValues.scale = ''
    } else if (keys === SpecificationMessages.structure) {
      setReqStructure(false)
      const structureValue = event.target.value
      if (structureValue === SpecificationMessages.SYGRNA) {
        setReqScale(false)
        setdefaultTrueForScale(true)
        state.dropDownValue.structure = SpecificationMessages.SYGRNA
        state.specificationValues.structure = SpecificationMessages.SYGRNAVal
        prciePhysicalFormat.scale = SpecificationMessages.Three
        state.specificationValues.scale = SpecificationMessages.ThreeVal
        state.specificationValues.purification = ''
        state.dropDownValue.purification = ''
        prciePhysicalFormat.purification = ''
        setDefaultTrue(false)
      } else if (structureValue === SpecificationMessages.CRRNA) {
        setDefaultTrue(true)
        setReqPuri(false)
        state.dropDownValue.structure = SpecificationMessages.CRRNA
        state.specificationValues.structure = SpecificationMessages.CRRNAVal
        state.dropDownValue.purification = SpecificationMessages.HPLC
        prciePhysicalFormat.purification = SpecificationMessages.HPLC
        state.specificationValues.purification = SpecificationMessages.HPLC
        prciePhysicalFormat.scale = ''
        state.specificationValues.scale = ''
      }
      prciePhysicalFormat.structure = structureValue
    } else if (keys === SpecificationMessages.ScaleofSynthesis) {
      setReqScale(false)
      const scaleLabel = event.target.value
      const scaleValue = scaleLabel.charAt(0)
      prciePhysicalFormat.scale = scaleValue
      state.specificationValues.scale = scaleLabel
      state.dropDownValue.scale = scaleValue
    } else if (keys === SpecificationMessages.Modified) {
      setReqMod(false)
      const modifiedValue = event.target.value
      if (modifiedValue === SpecificationMessages.Yes) {
        setDefaultTrue(false)
        setReqPuri(false)
        state.specificationValues.modification = SpecificationMessages.YesVal
      } else if (modifiedValue === SpecificationMessages.No) {
        setDefaultTrue(false)
        state.specificationValues.modification = SpecificationMessages.NoVal
      }
      state.dropDownValue.modification = modifiedValue
      prciePhysicalFormat.modification = modifiedValue
      state.specificationValues.purification = ''
      prciePhysicalFormat.purification = ''
    } else if (keys === SpecificationMessages.Purification) {
      setReqPuri(false)
      const purificationValue = event.target.value
      if (purificationValue === SpecificationMessages.DESALTVal) {
        state.specificationValues.purification = SpecificationMessages.DESALT
        prciePhysicalFormat.purification = SpecificationMessages.DESALT
      } else if (purificationValue === SpecificationMessages.STANDARDVal) {
        state.specificationValues.purification = SpecificationMessages.STANDARD
        prciePhysicalFormat.purification = SpecificationMessages.STANDARD
      } else if (purificationValue === SpecificationMessages.PUREDITVal) {
        state.specificationValues.purification = SpecificationMessages.PUREDIT
        prciePhysicalFormat.purification = SpecificationMessages.PUREDIT
      } else {
        state.specificationValues.purification = purificationValue
        prciePhysicalFormat.purification = purificationValue
      }
      if (
        state.dropDownValue.physicalMaterial === SpecificationMessages.RNA &&
        state.dropDownValue.species !== '' &&
        state.dropDownValue.scale !== '' &&
        state.dropDownValue.modification !== '' &&
        prciePhysicalFormat.purification !== ''
      ) {
        setOpen(false)
      }
    }
    prciePhysicalFormat.format = SpecificationMessages.dry
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: {
        ...state.dropDownValue,
      },
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
    dropDownResult(state.dropDownValue)
  }

  const onMaterialChange = (event): void => {
    dispatch({
      type: 'CHECK_ACTIVE_LINK',
      data: {
        ...state.checkActiveLink,
        specificationLink: false,
      },
    })
    setLoader(true)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    setOpen(false)
    setReqPhysical(false)
    const { value } = event.target
    setSelectedMaterial(value)
    setDefaultTrue(false)
    state.dropDownValue.physicalMaterial = value
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    prciePhysicalFormat.physicalMaterial = value
    if (value === SpecificationMessages.RNA) {
      prciePhysicalFormat.scale = ''
      prciePhysicalFormat.modification = ''
      prciePhysicalFormat.purification = ''
      prciePhysicalFormat.format = ''
      prciePhysicalFormat.species = ''
      prciePhysicalFormat.structure = ''
      setVector(SpecificationMessages.lv01)
      setAmount(SpecificationMessages.oneRom)
      setAliquotings(SpecificationMessages.Mul1X200)
      setLentiVirus(SpecificationMessages.lv01)
      setVolume(SpecificationMessages.pointTwo)
      setTiter(SpecificationMessages.powerof6)
      prciePhysicalFormat.titer = ''
      prciePhysicalFormat.amount = ''
      prciePhysicalFormat.vector = ''
      prciePhysicalFormat.volume = ''
      prciePhysicalFormat.aliquot = ''
      prciePhysicalFormat.lentivirusBackbone = ''
      state.specificationValues.physicalMaterial = SpecificationMessages.RNAVal
      setdefaultTrueForStructure(false)
      state.dropDownValue.structure = ''
      state.specificationValues.structure = ''
      prciePhysicalFormat.structure = ''
      prciePhysicalFormat.species = SpecificationMessages.SPCAS9Val
      state.dropDownValue.species = SpecificationMessages.SPCAS9
      state.specificationValues.species = SpecificationMessages.SPCAS9Val
    } else if (value === SpecificationMessages.DNA) {
      setReqSpecies(false)
      setReqStructure(false)
      setReqPuri(false)
      setReqScale(false)
      setReqMod(false)
      setAliquotings(SpecificationMessages.Mul1X200)
      setLentiVirus(SpecificationMessages.lv01)
      setVolume(SpecificationMessages.pointTwo)
      setTiter(SpecificationMessages.powerof6)
      setdefaultTrueForScale(false)
      setdefaultTrueForStructure(false)
      prciePhysicalFormat.titer = ''
      prciePhysicalFormat.volume = ''
      prciePhysicalFormat.aliquot = ''
      prciePhysicalFormat.lentivirusBackbone = ''
      prciePhysicalFormat.scale = ''
      prciePhysicalFormat.modification = ''
      prciePhysicalFormat.purification = ''
      prciePhysicalFormat.format = ''
      prciePhysicalFormat.species = ''
      prciePhysicalFormat.structure = ''
      state.dropDownValue.species = ''
      state.dropDownValue.structure = ''
      state.dropDownValue.modification = ''
      state.specificationValues.scale = ''
      state.specificationValues.purification = ''
      state.specificationValues.physicalMaterial = SpecificationMessages.DNAVal
      state.specificationValues.vector = SpecificationMessages.LV01Vec
      state.specificationValues.amount = SpecificationMessages.oneVal
      prciePhysicalFormat.vector = SpecificationMessages.lv01
      prciePhysicalFormat.amount = SpecificationMessages.oneVol
    } else if (value === SpecificationMessages.VIRUS) {
      setReqSpecies(false)
      setReqStructure(false)
      setReqPuri(false)
      setReqScale(false)
      setReqMod(false)
      setdefaultTrueForScale(false)
      setVector(SpecificationMessages.lv01)
      setAmount(SpecificationMessages.oneRom)
      setdefaultTrueForStructure(false)
      prciePhysicalFormat.amount = ''
      prciePhysicalFormat.vector = ''
      prciePhysicalFormat.scale = ''
      prciePhysicalFormat.modification = ''
      prciePhysicalFormat.purification = ''
      prciePhysicalFormat.format = ''
      prciePhysicalFormat.species = ''
      prciePhysicalFormat.structure = ''
      prciePhysicalFormat.lentivirusBackbone = SpecificationMessages.lv01
      prciePhysicalFormat.titer = SpecificationMessages.TenPSix
      prciePhysicalFormat.volume = SpecificationMessages.dotTwo
      prciePhysicalFormat.aliquot = SpecificationMessages.mul1x200
      state.dropDownValue.species = ''
      state.dropDownValue.structure = ''
      state.dropDownValue.modification = ''
      state.specificationValues.scale = ''
      state.specificationValues.purification = ''
      state.specificationValues.physicalMaterial =
        SpecificationMessages.VIRUSVal
      state.dropDownValue.titer = SpecificationMessages.TenPSix
      state.dropDownValue.volume = SpecificationMessages.dotTwo
      state.specificationValues.titer = SpecificationMessages.TenPSixVal
      state.specificationValues.volume = SpecificationMessages.dotTwoVal
      state.specificationValues.lentivirusBackbone =
        SpecificationMessages.LV01Val
      state.specificationValues.aliquot = SpecificationMessages.mul1x200Val
    }
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: state.dropDownValue,
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
    if (value !== SpecificationMessages.noSelection) {
      dropDownResult(state.dropDownValue)
    }
  }

  const onLentiVirusChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    const { value } = event.target
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    prciePhysicalFormat.lentivirusBackbone = value
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    setLentiVirus(value)

    let lentiVirusVal = ''
    if (value === SpecificationMessages.lv01) {
      lentiVirusVal = SpecificationMessages.LV01Val
    } else if (value === SpecificationMessages.LV02) {
      lentiVirusVal = SpecificationMessages.LV02Val
    } else if (value === SpecificationMessages.LV03) {
      lentiVirusVal = SpecificationMessages.LV03Val
    } else if (value === SpecificationMessages.LV04) {
      lentiVirusVal = SpecificationMessages.LV04Val
    } else if (value === SpecificationMessages.LV05) {
      lentiVirusVal = SpecificationMessages.LV05Val
    } else if (value === SpecificationMessages.LV08) {
      lentiVirusVal = SpecificationMessages.LV08Val
    } else if (value === SpecificationMessages.LV13) {
      lentiVirusVal = SpecificationMessages.LV13Val
    } else if (value === SpecificationMessages.LV14) {
      lentiVirusVal = SpecificationMessages.LV14Val
    } else if (value === SpecificationMessages.LV15) {
      lentiVirusVal = SpecificationMessages.LV15Val
    } else if (value === SpecificationMessages.LV16) {
      lentiVirusVal = SpecificationMessages.LV16Val
    } else if (value === SpecificationMessages.LV17) {
      lentiVirusVal = SpecificationMessages.LV17Val
    }
    state.specificationValues.lentivirusBackbone = lentiVirusVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
  }

  const onAliquotingChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    const { value } = event.target

    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    let aliq = ''
    let aliqVal = ''
    if (value === SpecificationMessages.Mul1X200) {
      aliq = SpecificationMessages.mul1x200
      aliqVal = SpecificationMessages.mul1x200Val
    } else if (value === SpecificationMessages.Mul2X100) {
      aliq = SpecificationMessages.mul2X100
      aliqVal = SpecificationMessages.mul2X100Val
    } else if (value === SpecificationMessages.Mul4X50) {
      aliq = SpecificationMessages.mul4X50
      aliqVal = SpecificationMessages.mul4X50Val
    } else if (value === SpecificationMessages.Mul8X25) {
      aliq = SpecificationMessages.mul8X25
      aliqVal = SpecificationMessages.mul8X25Val
    } else if (value === SpecificationMessages.Mul5X20) {
      aliq = SpecificationMessages.mul5X20
      aliqVal = SpecificationMessages.mul5X20Val
    } else if (value === SpecificationMessages.Mul2X50) {
      aliq = SpecificationMessages.mul2X50
      aliqVal = SpecificationMessages.mul2X50Val
    } else if (value === SpecificationMessages.Mul4X25) {
      aliq = SpecificationMessages.mul4X25
      aliqVal = SpecificationMessages.mul4X25Val
    } else if (value === SpecificationMessages.Mul5X200) {
      aliq = SpecificationMessages.mul5X200
      aliqVal = SpecificationMessages.mul5X200Val
    } else if (value === SpecificationMessages.Mul10X100) {
      aliq = SpecificationMessages.mul10X100
      aliqVal = SpecificationMessages.mul10X100Val
    } else if (value === SpecificationMessages.Mul20X50) {
      aliq = SpecificationMessages.mul20X50
      aliqVal = SpecificationMessages.mul20X50Val
    } else if (value === SpecificationMessages.Mul40X25) {
      aliq = SpecificationMessages.mul40X25
      aliqVal = SpecificationMessages.mul40X25Val
    } else if (value === SpecificationMessages.Mul25X200) {
      aliq = SpecificationMessages.mul25X200
      aliqVal = SpecificationMessages.mul25X200Val
    } else if (value === SpecificationMessages.Mul50X100) {
      aliq = SpecificationMessages.mul50X100
      aliqVal = SpecificationMessages.mul50X100Val
    } else if (value === SpecificationMessages.Mul100X50) {
      aliq = SpecificationMessages.mul100X50
      aliqVal = SpecificationMessages.mul100X50Val
    } else if (value === SpecificationMessages.Mul200X25) {
      aliq = SpecificationMessages.mul200X25
      aliqVal = SpecificationMessages.mul200X25Val
    } else if (value === SpecificationMessages.Mul10X200) {
      aliq = SpecificationMessages.mul10X200
      aliqVal = SpecificationMessages.mul10X200Val
    } else if (value === SpecificationMessages.Mul20X100) {
      aliq = SpecificationMessages.mul20X100
      aliqVal = SpecificationMessages.mul20X100Val
    } else if (value === SpecificationMessages.Mul40X50) {
      aliq = SpecificationMessages.mul40X50
      aliqVal = SpecificationMessages.mul40X50Val
    } else if (value === SpecificationMessages.Mul80X25) {
      aliq = SpecificationMessages.mul80X25
      aliqVal = SpecificationMessages.mul80X25Val
    } else if (value === SpecificationMessages.Mul50X20) {
      aliq = SpecificationMessages.mul50X20
      aliqVal = SpecificationMessages.mul50X20Val
    } else if (value === SpecificationMessages.Mul100X20) {
      aliq = SpecificationMessages.mul100X20
      aliqVal = SpecificationMessages.mul100X20Val
    } else if (value === SpecificationMessages.Mul10X20) {
      aliq = SpecificationMessages.mul10X20
      aliqVal = SpecificationMessages.mul10X20Val
    }
    prciePhysicalFormat.aliquot = aliq
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    state.specificationValues.aliquot = aliqVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
    setAliqFlag(true)
    setAliquotings(value)
  }

  const onAmountChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    const { value } = event.target
    setAmount(value)
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    let amt = ''
    let amtVal = ''
    if (value === SpecificationMessages.oneRom) {
      amt = SpecificationMessages.oneVol
      amtVal = SpecificationMessages.oneVolVal
    } else if (value === SpecificationMessages.tenRom) {
      amt = SpecificationMessages.ten
      amtVal = SpecificationMessages.tenVal
    } else if (value === SpecificationMessages.twentyFiveRom) {
      amt = SpecificationMessages.TwentyFive
      amtVal = SpecificationMessages.TwentyFiveVal
    } else if (value === SpecificationMessages.hundredRom) {
      amt = SpecificationMessages.hundred
      amtVal = SpecificationMessages.hundredVal
    }
    prciePhysicalFormat.amount = amt
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    state.specificationValues.amount = amtVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
  }

  const onVectorChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    const { value } = event.target
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    prciePhysicalFormat.vector = value
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })
    setVector(value)

    let vecVal = ''
    if (value === SpecificationMessages.lv01) {
      vecVal = SpecificationMessages.LV01Vec
    } else if (value === SpecificationMessages.LV02) {
      vecVal = SpecificationMessages.LV02Vec
    } else if (value === SpecificationMessages.LV03) {
      vecVal = SpecificationMessages.LV03Vec
    } else if (value === SpecificationMessages.LV04) {
      vecVal = SpecificationMessages.LV04Vec
    } else if (value === SpecificationMessages.LV05) {
      vecVal = SpecificationMessages.LV05Vec
    } else if (value === SpecificationMessages.LV08) {
      vecVal = SpecificationMessages.LV08Vec
    } else if (value === SpecificationMessages.LV13) {
      vecVal = SpecificationMessages.LV13Vec
    } else if (value === SpecificationMessages.LV14) {
      vecVal = SpecificationMessages.LV14Vec
    } else if (value === SpecificationMessages.LV15) {
      vecVal = SpecificationMessages.LV15Vec
    } else if (value === SpecificationMessages.LV16) {
      vecVal = SpecificationMessages.LV16Vec
    } else if (value === SpecificationMessages.LV17) {
      vecVal = SpecificationMessages.LV17Vec
    } else if (value === SpecificationMessages.p01) {
      vecVal = SpecificationMessages.p01Vec
    } else if (value === SpecificationMessages.p02) {
      vecVal = SpecificationMessages.p02Vec
    } else if (value === SpecificationMessages.p03) {
      vecVal = SpecificationMessages.p03Vec
    } else if (value === SpecificationMessages.p04) {
      vecVal = SpecificationMessages.p04Vec
    } else if (value === SpecificationMessages.p05) {
      vecVal = SpecificationMessages.p05Vec
    }

    state.specificationValues.vector = vecVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })
  }

  const onTiterChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    setVolFlag(false)
    setAliqFlag(false)
    const { value } = event.target
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
    let tit = ''
    let vol = ''
    let titVal = ''
    if (value === SpecificationMessages.powerof6) {
      tit = SpecificationMessages.TenPSix
      titVal = SpecificationMessages.TenPSixVal
      state.dropDownValue.volume = SpecificationMessages.dotTwo
    } else if (value === SpecificationMessages.powerof7) {
      tit = SpecificationMessages.TenPSeven
      titVal = SpecificationMessages.TenPSevenVal
      state.dropDownValue.volume = SpecificationMessages.dotTwo
    } else if (value === SpecificationMessages.powerof8) {
      tit = SpecificationMessages.TenPEight
      vol = SpecificationMessages.dotOne
      titVal = SpecificationMessages.TenPEightVal
      state.dropDownValue.volume = SpecificationMessages.dotOne
    } else if (value === SpecificationMessages.powerof9) {
      tit = SpecificationMessages.TenPNine
      titVal = SpecificationMessages.TenPNineVal
      state.dropDownValue.volume = SpecificationMessages.dotOne
    }
    prciePhysicalFormat.titer = tit
    prciePhysicalFormat.volume = vol

    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })

    state.specificationValues.titer = titVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })

    const requestData = { ...state.dropDownValue, titer: tit }

    setTiter(value)
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: requestData,
    })

    dropDownResult(requestData)
  }

  const onVolumeChange = (event): void => {
    setLoader(false)
    if (state.stepNo !== 2) {
      setInitialState()
    }
    setVolFlag(true)
    setAliqFlag(false)
    const { value } = event.target
    const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }

    let vol = ''
    let volVal = ''
    let tit = ''
    if (value === SpecificationMessages.pointTwo) {
      vol = SpecificationMessages.dotTwo
      volVal = SpecificationMessages.dotTwoVal
    } else if (value === SpecificationMessages.pointOne) {
      vol = SpecificationMessages.dotOne
      volVal = SpecificationMessages.dotOneVal
    } else if (value === SpecificationMessages.volOne) {
      vol = SpecificationMessages.oneVol
      volVal = SpecificationMessages.oneVolVal
    } else if (value === SpecificationMessages.volTwo) {
      vol = SpecificationMessages.twoVol
      volVal = SpecificationMessages.twoVolVal
    } else if (value === SpecificationMessages.volFive) {
      vol = SpecificationMessages.fiveVol
      volVal = SpecificationMessages.fiveVolVal
    }
    prciePhysicalFormat.volume = vol
    prciePhysicalFormat.titer = state.priceCallData.physicalFormat.titer
    tit = state.priceCallData.physicalFormat.titer

    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, physicalFormat: prciePhysicalFormat },
    })

    state.specificationValues.volume = volVal
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: { ...state.specificationValues },
    })

    const volumeData = { ...state.dropDownValue, volume: vol, titer: tit }

    setVolume(value)
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: volumeData,
    })

    dropDownResult(volumeData)
  }

  const onClickNextButton = (): void => {
    if (state.stepNo === 2) {
      dispatch({ type: 'TRACE_ON_CLICK', data: false })
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      (state.priceCallData.physicalFormat.species === '' ||
        state.priceCallData.physicalFormat.scale === '' ||
        state.priceCallData.physicalFormat.modification === '' ||
        state.priceCallData.physicalFormat.purification === '' ||
        state.priceCallData.physicalFormat.structure === '')
    ) {
      setOpen(true)
      window.scrollTo(0, 0)
    }
    if (selectedMaterial === SpecificationMessages.noSelection) {
      setOpen(true)
      setReqPhysical(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.species === ''
    ) {
      setReqSpecies(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.structure === ''
    ) {
      setReqStructure(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.scale === ''
    ) {
      setReqScale(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.modification === ''
    ) {
      setReqMod(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.purification === ''
    ) {
      setReqPuri(true)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.species !== '' &&
      state.priceCallData.physicalFormat.scale !== '' &&
      state.priceCallData.physicalFormat.modification !== '' &&
      state.priceCallData.physicalFormat.purification !== '' &&
      state.priceCallData.physicalFormat.structure !== ''
    ) {
      setOpen(false)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.species !== ''
    ) {
      setReqSpecies(false)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.structure !== ''
    ) {
      setReqStructure(false)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.scale !== ''
    ) {
      setReqScale(false)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.modification !== ''
    ) {
      setReqMod(false)
    }
    if (
      selectedMaterial === SpecificationMessages.RNA &&
      state.priceCallData.physicalFormat.purification !== ''
    ) {
      setReqPuri(false)
    }
    const updateCountryCode = {
      ...state.priceCallData,
      country: props.productDetails.region,
    }
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: updateCountryCode,
    })
    if (selectedMaterial !== SpecificationMessages.noSelection) {
      semiCrisprgrnaPriceCall(updateCountryCode)
    }
  }

  const getScaleValues = (): JSX.Element[] | null => {
    if (dropDownResponseList.scale !== null) {
      return dropDownResponseList.scale.map((scale, index) => {
        return (
          <RadioGroup
            aria-label="scale"
            name="scale"
            value={
              state.specificationValues.scale === SpecificationMessages.TwoVal
                ? SpecificationMessages.TwoVal
                : state.specificationValues.scale ===
                    SpecificationMessages.ThreeVal
                  ? SpecificationMessages.ThreeVal
                  : state.specificationValues.scale ===
                      SpecificationMessages.FiveVal
                    ? SpecificationMessages.FiveVal
                    : defaultTrueForScale && Object.values(scale)[1] === 'true'
                      ? SpecificationMessages.ThreeVal
                      : ''
            }
            key={index}
            onChange={(e) =>
              getValue(e, SpecificationMessages.ScaleofSynthesis)
            }
          >
            <FormControlLabel
              control={
                <StyledRadio
                  isConfiguratorsRedesign="true"
                  className={classes.radio}
                />
              }
              label={Object.values(scale)[0]}
              value={Object.values(scale)[0]}
              disabled={Object.values(scale)[1] === 'false' ? true : false}
              className={classes.noDrop}
            />
          </RadioGroup>
        )
      })
    }
    return null
  }

  const getPurificationValues = (): JSX.Element[] | null => {
    if (dropDownResponseList.purification !== null) {
      return dropDownResponseList.purification.map((purification, index) => {
        return (
          <RadioGroup
            aria-label="purification"
            name="purification"
            value={
              state.specificationValues.purification ===
              SpecificationMessages.DESALT
                ? SpecificationMessages.DESALTVal
                : state.specificationValues.purification ===
                    SpecificationMessages.STANDARD
                  ? SpecificationMessages.STANDARDVal
                  : state.specificationValues.purification ===
                      SpecificationMessages.PUREDIT
                    ? SpecificationMessages.PUREDITVal
                    : state.specificationValues.purification ===
                        SpecificationMessages.HPLC
                      ? SpecificationMessages.HPLC
                      : defaultTrue && Object.values(purification)[1] === 'true'
                        ? SpecificationMessages.HPLC
                        : ''
            }
            key={index}
            onChange={(e) => getValue(e, SpecificationMessages.Purification)}
          >
            <FormControlLabel
              control={
                <StyledRadio
                  isConfiguratorsRedesign="true"
                  className={classes.radio}
                />
              }
              label={
                state.dropDownValue.structure === SpecificationMessages.SYGRNA
                  ? Object.keys(purification)[1] ===
                    SpecificationMessages.Puredit
                    ? Object.values(purification)[1]
                    : Object.keys(purification)[1]
                  : Object.keys(purification)[0]
              }
              value={
                state.dropDownValue.structure === SpecificationMessages.SYGRNA
                  ? Object.keys(purification)[1] ===
                    SpecificationMessages.Puredit
                    ? Object.values(purification)[1]
                    : Object.keys(purification)[1]
                  : Object.keys(purification)[0]
              }
              disabled={
                Object.values(purification)[1] === 'false' ? true : false
              }
              className={classes.noDrop}
            />
          </RadioGroup>
        )
      })
    }
    return null
  }

  const getStructureValues = (): JSX.Element[] | null => {
    if (dropDownResponseList.structure) {
      return dropDownResponseList.structure.map((structure, index) => {
        return (
          <RadioGroup
            aria-label="structure"
            name="structure"
            value={
              state.dropDownValue.structure === SpecificationMessages.SYGRNA
                ? SpecificationMessages.SYGRNA
                : state.dropDownValue.structure === SpecificationMessages.CRRNA
                  ? SpecificationMessages.CRRNA
                  : defaultTrueForStructure &&
                      Object.values(structure)[1] === 'true'
                    ? SpecificationMessages.CRRNA
                    : ''
            }
            key={index}
            onChange={(e) => getValue(e, SpecificationMessages.structure)}
          >
            <FormControlLabel
              control={
                <StyledRadio
                  isConfiguratorsRedesign="true"
                  className={classes.radio}
                />
              }
              label={
                Object.values(structure)[0] === SpecificationMessages.SYGRNAVal
                  ? SpecificationMessages.SYGRNAVal
                  : Object.values(structure)[0]
              }
              value={
                Object.values(structure)[0] === SpecificationMessages.SYGRNAVal
                  ? SpecificationMessages.SYGRNA
                  : SpecificationMessages.CRRNA
              }
              disabled={Object.values(structure)[1] === 'false' ? true : false}
              className={classes.noDrop}
            />
          </RadioGroup>
        )
      })
    }
    return null
  }

  const removeNullAndTypeNm = (): void => {
    if (data !== undefined) {
      if (data.getDropDownList.modification !== null) {
        const result = getData(data.getDropDownList.modification)
        result.forEach((sc) => {
          delete sc.__typename
        })
        const volumeData = {
          ...state.dropDownResponseList,
          modification: result,
        }
        dispatch({ type: 'UPDATE_DROPDOWN_RESPONSE', data: volumeData })
      }
      if (data.getDropDownList.companionProducts) {
        const result = getData(data.getDropDownList.companionProducts)
        if (result.length) {
          const companionProducts: any[] = []
          result.forEach((item) => {
            if (item) {
              delete item.__typename
              companionProducts.push(item.key)
            }
          })
          dispatch({
            type: 'SET_COMPANION_PRODUCT_INFORMATION',
            data: companionProducts,
          })
        }
      }
    }
    if (data !== undefined && data.getDropDownList.purification) {
      const purificationResult = getData(data.getDropDownList.purification)
      if (purificationResult && purificationResult.length > 0) {
        const filteredPurificationResult = purificationResult.filter(
          (purification) => {
            return purification.visible === 'true'
          }
        )
        if (filteredPurificationResult.length === 1) {
          const prciePhysicalFormat = { ...state.priceCallData.physicalFormat }
          state.specificationValues.purification = Object.keys(
            filteredPurificationResult[0]
          )[0]
          prciePhysicalFormat.purification = Object.keys(
            filteredPurificationResult[0]
          )[0]
          dispatch({
            type: 'UPDATE_PRICE_CALL',
            data: {
              ...state.priceCallData,
              physicalFormat: prciePhysicalFormat,
            },
          })
          dispatch({
            type: 'UPDATE_SPECIFICATION_VALUES',
            data: { ...state.specificationValues },
          })
          if (
            prciePhysicalFormat.species !== '' &&
            prciePhysicalFormat.scale !== '' &&
            prciePhysicalFormat.modification !== '' &&
            prciePhysicalFormat.purification !== '' &&
            prciePhysicalFormat.structure !== ''
          ) {
            setOpen(false)
          }
        }
      }
    }

    if (
      data !== undefined &&
      data.getDropDownList.purification &&
      data.getDropDownList.scale &&
      data.getDropDownList.structure &&
      data.getDropDownList.modification
    ) {
      const scaleResult = getData(data.getDropDownList.scale)
      scaleResult.forEach((scale) => {
        delete scale.__typename
      })
      const purificationResult = getData(data.getDropDownList.purification)
      purificationResult.forEach((sc) => {
        delete sc.__typename
      })
      const structureResult = getData(data.getDropDownList.structure)
      structureResult.forEach((sc) => {
        delete sc.__typename
      })
      const modificationResult = getData(data.getDropDownList.modification)
      modificationResult.forEach((sc) => {
        delete sc.__typename
      })
      const filteredData = {
        ...state.dropDownResponseList,
        scale: scaleResult,
        purification: purificationResult,
        structure: structureResult,
        modification: modificationResult,
      }
      dispatch({ type: 'UPDATE_DROPDOWN_RESPONSE', data: filteredData })
    }
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getDropDownList.serverError) {
        dispatch({
          type: 'UPDATE_DROPDOWN_RESPONSE',
          data: data.getDropDownList,
        })
        removeNullAndTypeNm()
        if (
          state.priceCallData.physicalFormat.species !== '' &&
          state.priceCallData.physicalFormat.scale !== '' &&
          state.priceCallData.physicalFormat.modification !== '' &&
          state.priceCallData.physicalFormat.purification !== '' &&
          state.priceCallData.physicalFormat.structure !== ''
        ) {
          setOpen(false)
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    dropDownResult(state.dropDownValue)
    // TODO: need a test before we refactor these dependencies
  }, [data])

  return (
    <div>
      <ErrorAlert open={open} setOpen={setOpen} message={message} />
      <Grid container>
        <Grid item sm={6}>
          <h4 className={classes.subHead}>
            <FormattedMessage {...messages.CONF_SPECIFICATIONS_crisprgrna} />
          </h4>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.recommendationText}>
        <PerformanceGuaranteePopUp />
      </Grid>
      <div className={classes.contentWrapper}>
        <Box>
          <Formik
            initialValues={{
              materialName: (
                <FormattedMessage
                  {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna}
                />
              ),
            }}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                actions.setSubmitting(false)
              }, 1000)
            }}
          >
            {() => (
              <>
                <Grid container spacing={2} className={classes.fieldLabel}>
                  <Grid item xs={4}>
                    <Field
                      name="materialName"
                      component={LiquidSelectAdapter}
                      label={
                        <FormattedMessage
                          {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL}
                        />
                      }
                      onChange={onMaterialChange}
                      value={
                        selectedMaterial ===
                          SpecificationMessages.noSelection &&
                        state.dropDownValue.physicalMaterial !== ''
                          ? state.dropDownValue.physicalMaterial
                          : selectedMaterial
                      }
                      options={[...dropdownType(dropDownResponseList)]}
                      filled
                    />
                    <Grid className={reqPhysical ? '' : classes.hideRow}>
                      <div className={classes.textColor}>
                        <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                {selectedMaterial === SpecificationMessages.RNA ? (
                  dropdownload && loader ? (
                    ''
                  ) : (
                    <>
                      <Grid item xs={6} className={classes.recommendationText}>
                        <CrisprgrnaRecommendationPopUp />
                      </Grid>
                      <Grid
                        container
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={6}>
                          <div className={classes.label}>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_CRISPR_SPECIES_crisprgrna}
                            />
                          </div>
                          <div className={classes.fieldLabelPadding}>
                            <RadioGroup
                              aria-label="species"
                              name="species"
                              value={
                                state.dropDownValue.species ===
                                SpecificationMessages.SPCAS9
                                  ? SpecificationMessages.SPCAS9
                                  : state.dropDownValue.species ===
                                      SpecificationMessages.FNCAS9
                                    ? SpecificationMessages.FNCAS9
                                    : ''
                              }
                              onChange={(e) =>
                                getValue(e, SpecificationMessages.CRISPRSpecies)
                              }
                            >
                              <FormControlLabel
                                control={
                                  <StyledRadio
                                    isConfiguratorsRedesign="true"
                                    className={classes.radio}
                                  />
                                }
                                label={
                                  <FormattedMessage
                                    {...messages.CONF_SPECIFICATION_CRISPR_SPECIES_SpCas9_crisprgrna}
                                  />
                                }
                                value={SpecificationMessages.SPCAS9}
                              />
                            </RadioGroup>
                          </div>
                          <Grid className={reqSpecies ? '' : classes.hideRow}>
                            <div className={classes.textColor}>
                              <FormattedMessage
                                {...messages.CONF_REQUIRED_FIELD}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container className={classes.fieldLabel}>
                        <Grid item xs={6}>
                          <div className={classes.label}>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_STRUCTURE_crisprgrna}
                            />
                          </div>
                          <div className={classes.fieldLabelPadding}>
                            {getStructureValues()}
                          </div>
                          <Grid className={reqStructure ? '' : classes.hideRow}>
                            <div className={classes.textColor}>
                              <FormattedMessage
                                {...messages.CONF_REQUIRED_FIELD}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container className={classes.fieldLabel}>
                        <Grid item xs={6}>
                          <div className={classes.label}>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_SYNTHESIS_SCALE_crisprgrna}
                            />
                          </div>
                          <div className={classes.fieldLabelPadding}>
                            {getScaleValues()}
                          </div>
                          <Grid className={reqScale ? '' : classes.hideRow}>
                            <div className={classes.textColor}>
                              <FormattedMessage
                                {...messages.CONF_REQUIRED_FIELD}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container className={classes.fieldLabel}>
                        <Grid item xs={6}>
                          <div className={classes.label}>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_MODIFIED_crisprgrna}
                            />
                            <Tooltip
                              title={
                                <FormattedMessage
                                  {...messages.CONF_SPECIFICATION_MODIFIED_HELP_TEXT_crisprgrna}
                                />
                              }
                              classes={{
                                tooltip: clsx(
                                  classes.InfoPopup,
                                  classes.marginPopup
                                ),
                                arrow: classes.arrow1,
                              }}
                              arrow
                              placement="bottom-start"
                            >
                              <InfoIcon
                                color="primary"
                                className={classes.InfoIcon}
                              />
                            </Tooltip>
                          </div>
                          <div className={classes.fieldLabelPadding}>
                            <RadioGroup
                              aria-label="modified"
                              name="modified"
                              value={
                                state.dropDownValue.modification ===
                                SpecificationMessages.Yes
                                  ? SpecificationMessages.Yes
                                  : state.dropDownValue.modification ===
                                      SpecificationMessages.No
                                    ? SpecificationMessages.No
                                    : ''
                              }
                              onChange={(e) =>
                                getValue(e, SpecificationMessages.Modified)
                              }
                            >
                              <FormControlLabel
                                control={
                                  <StyledRadio
                                    isConfiguratorsRedesign="true"
                                    className={classes.radio}
                                  />
                                }
                                label={
                                  <FormattedMessage
                                    {...messages.CONF_SPECIFICATION_MODIFIED_YES_crisprgrna}
                                  />
                                }
                                value={SpecificationMessages.Yes}
                              />
                              <FormControlLabel
                                control={
                                  <StyledRadio
                                    isConfiguratorsRedesign="true"
                                    className={classes.radio}
                                  />
                                }
                                label={
                                  <FormattedMessage
                                    {...messages.CONF_SPECIFICATION_MODIFIED_NO_crisprgrna}
                                  />
                                }
                                value={SpecificationMessages.No}
                              />
                            </RadioGroup>
                          </div>
                          <Grid className={reqMod ? '' : classes.hideRow}>
                            <div className={classes.textColor}>
                              <FormattedMessage
                                {...messages.CONF_REQUIRED_FIELD}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                      {state.priceCallData.physicalFormat.structure !== '' ? (
                        <Grid container className={classes.fieldLabel}>
                          <Grid item xs={6}>
                            <div className={classes.label}>
                              <FormattedMessage
                                {...messages.CONF_SPECIFICATION_PURIFICATION_crisprgrna}
                              />
                              <Tooltip
                                title={
                                  <>
                                    <Typography
                                      variant="body2"
                                      className={classes.purificationHelpText}
                                    >
                                      <FormattedMessage
                                        {...messages.SEMICONF_PURIFICATION_HELP_TEXT_ONE}
                                      />
                                    </Typography>
                                    <Typography variant="body2">
                                      <FormattedMessage
                                        {...messages.SEMICONF_PURIFICATION_HELP_TEXT_TWO}
                                      />
                                    </Typography>
                                  </>
                                }
                                classes={{
                                  tooltip: classes.InfoPopup,
                                  arrow: classes.arrow,
                                }}
                                arrow
                                placement="bottom-start"
                              >
                                <InfoIcon
                                  color="primary"
                                  className={classes.InfoIcon}
                                />
                              </Tooltip>
                            </div>
                            <div className={classes.fieldLabelPadding}>
                              {getPurificationValues()}
                            </div>
                            <Grid className={reqPuri ? '' : classes.hideRow}>
                              <div className={classes.textColor}>
                                <FormattedMessage
                                  {...messages.CONF_REQUIRED_FIELD}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        ''
                      )}
                      <Grid
                        container
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={6}>
                          <div className={classes.label}>
                            <FormattedMessage
                              {...messages.CONF_SPECIFICATION_FORMAT_crisprgrna}
                            />
                          </div>
                          <FormattedMessage
                            {...messages.CONF_SPECIFICATION_DRY_crisprgrna}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )
                ) : selectedMaterial === SpecificationMessages.DNA ? (
                  dropdownload && loader ? (
                    ''
                  ) : (
                    <>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={10}>
                          <Field
                            name="vector"
                            component={LiquidSelectAdapter}
                            label={
                              <FormattedMessage
                                {...messages.CONF_DNA_SPECIFICATION_crispgrna}
                              />
                            }
                            value={vector}
                            onChange={onVectorChange}
                            className={classes.vectorLabel2}
                            options={[
                              ...vectorDNADropdown(dropDownResponseList),
                            ]}
                            filled
                          />
                          <span className={classes.vectorLabel}>
                            <FormattedMessage
                              {...messages.CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna}
                            />
                          </span>
                          <span className={classes.linkStyle}>
                            <Link
                              href={vectorURL}
                              className={classes.linkFontWeight}
                            >
                              <FormattedMessage
                                {...messages.CONF_DNA_LINK_SPECIFICATION_crispgrna}
                              />
                            </Link>
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={4}>
                          <Field
                            name="amount"
                            component={LiquidSelectAdapter}
                            label={
                              <span>
                                <FormattedMessage
                                  {...messages.CONF_AMOUNT_DNA_SPECIFICATION_crispgrna}
                                />
                                <Tooltip
                                  title={
                                    <React.Fragment>
                                      <div>
                                        <FormattedMessage
                                          {...messages.SEMICONF_HELP_ICON_TEXT_AMOUNT_crisprgrna}
                                        />
                                      </div>
                                    </React.Fragment>
                                  }
                                  placement="right"
                                  classes={{
                                    tooltip: classes.InfoPopup,
                                    arrow: classes.arrow1,
                                  }}
                                  arrow
                                >
                                  <InfoIcon
                                    color="primary"
                                    aria-label="info"
                                    className={classes.InfoIcon}
                                  ></InfoIcon>
                                </Tooltip>
                              </span>
                            }
                            value={amount}
                            onChange={onAmountChange}
                            options={[
                              ...amountDNADropdown(dropDownResponseList),
                            ]}
                            filled
                          />
                        </Grid>
                      </Grid>
                    </>
                  )
                ) : selectedMaterial === SpecificationMessages.VIRUS ? (
                  dropdownload && loader ? (
                    ''
                  ) : (
                    <>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={10}>
                          <Field
                            name="lentivirus"
                            component={LiquidSelectAdapter}
                            label={
                              <FormattedMessage
                                {...messages.CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna}
                              />
                            }
                            value={lentiVirus}
                            onChange={onLentiVirusChange}
                            options={[
                              ...lentivirusDNADropdown(dropDownResponseList),
                            ]}
                            className={classes.vectorLabel2}
                            filled
                          />
                          <span className={classes.vectorLabel}>
                            <FormattedMessage
                              {...messages.CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna}
                            />
                          </span>
                          <span className={classes.linkStyle}>
                            <Link
                              href={vectorURL}
                              className={classes.linkFontWeight}
                            >
                              <FormattedMessage
                                {...messages.CONF_DNA_LINK_SPECIFICATION_crispgrna}
                              />
                            </Link>
                          </span>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={4}>
                          <Field
                            name="titerField"
                            component={LiquidSelectAdapter}
                            label={
                              <span>
                                <FormattedMessage
                                  {...messages.CONF_VIRUS_TITER_SPECIFICATION_crispgrna}
                                />
                                <Tooltip
                                  title={
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_TITER_crisprgrna}
                                    />
                                  }
                                  placement="right"
                                  classes={{
                                    tooltip: classes.InfoPopup,
                                    arrow: classes.arrow1,
                                  }}
                                  arrow
                                >
                                  <InfoIcon
                                    color="primary"
                                    aria-label="info"
                                    className={classes.InfoIcon}
                                  ></InfoIcon>
                                </Tooltip>
                              </span>
                            }
                            value={titer}
                            onChange={onTiterChange}
                            options={[...titerDropdown(dropDownResponseList)]}
                            filled
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={4}>
                          <Field
                            name="volume"
                            component={LiquidSelectAdapter}
                            label={
                              <span>
                                <FormattedMessage
                                  {...messages.CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna}
                                />
                                <Tooltip
                                  title={
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_VOLUME_crisprgrna}
                                    />
                                  }
                                  placement="right"
                                  classes={{
                                    tooltip: classes.InfoPopup,
                                    arrow: classes.arrow1,
                                  }}
                                  arrow
                                >
                                  <InfoIcon
                                    color="primary"
                                    aria-label="info"
                                    className={classes.InfoIcon}
                                  ></InfoIcon>
                                </Tooltip>
                              </span>
                            }
                            value={volume}
                            onChange={onVolumeChange}
                            options={[...volumeDropdown(dropDownResponseList)]}
                            filled
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldLabel}
                        alignItems="flex-end"
                      >
                        <Grid item xs={4}>
                          <Field
                            name="aliquoting"
                            component={LiquidSelectAdapter}
                            label={
                              <span>
                                <FormattedMessage
                                  {...messages.CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna}
                                />
                                <Tooltip
                                  title={
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_ALIQUOTING_crisprgrna}
                                    />
                                  }
                                  placement="right"
                                  classes={{
                                    tooltip: classes.InfoPopup,
                                    arrow: classes.arrow1,
                                  }}
                                  arrow
                                >
                                  <InfoIcon
                                    color="primary"
                                    aria-label="info"
                                    className={classes.InfoIcon}
                                  ></InfoIcon>
                                </Tooltip>
                              </span>
                            }
                            value={aliquotings}
                            onChange={onAliquotingChange}
                            options={[
                              ...aliquotingDropdown(dropDownResponseList),
                            ]}
                            filled
                          />
                        </Grid>
                      </Grid>
                    </>
                  )
                ) : (
                  ''
                )}
              </>
            )}
          </Formik>
        </Box>
      </div>
      <div>
        {selectedMaterial === SpecificationMessages.RNA && isEurope ? (
          dropdownload && loader ? (
            ''
          ) : (
            <>
              <Grid item xs={6} className={classes.customCrisprSolnLink}>
                <CustomCrisprSolutionsPopUp />
              </Grid>
            </>
          )
        ) : (
          ''
        )}
      </div>
      <Grid container>
        <Grid item sm={6}>
          <Button
            color="primary"
            variant="contained"
            className={classes.nextButton}
            onClick={onClickNextButton}
          >
            <FormattedMessage {...messages.CONTINUE} />
          </Button>
        </Grid>
      </Grid>
      {((dropdownload &&
        state.stepNo === 2 &&
        !state.checkActiveLink.specificationLink) ||
        priceload) && <CircleLoader />}
    </div>
  )
}

export default Specifications
